import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

function Invite() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    
    const [status, setStatus] = useState("verifying"); // verifying, valid, invalid
    const [inviteInfo, setInviteInfo] = useState(null);
    const API_URL = window.location.hostname === "localhost"
        ? (process.env.REACT_APP_API_URL || "http://localhost:3173")
        : window.location.origin;

    useEffect(() => {
        if (!token) {
            setStatus("invalid");
            return;
        }

        // トークンの有効性を確認
        fetch(`${API_URL}/api/verify-invitation?token=${token}`)
            .then(res => res.json())
            .then(data => {
                if (data.valid) {
                    setInviteInfo(data);
                    setStatus("valid");
                } else {
                    setStatus("invalid");
                }
            })
            .catch(() => setStatus("invalid"));
    }, [token]);

    const handleGoogleLogin = () => {
        // 先ほど修正した inviteToken をクエリに乗せてバックエンドへ飛ばす
        window.location.href = `${API_URL}/api/auth/google?inviteToken=${token}`;
    };

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center p-3 sm:p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-5 sm:p-8 text-center">
                <h1 className="text-xl sm:text-2xl font-bold text-gray-800 mb-6">招待アカウント</h1>

                {status === "verifying" && (
                    <div className="flex flex-col items-center">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-4"></div>
                        <p className="text-gray-600">招待状を確認しています...</p>
                    </div>
                )}

                {status === "invalid" && (
                    <div>
                        <div className="text-red-500 text-4xl sm:text-5xl mb-4">⚠️</div>
                        <p className="text-gray-800 font-bold mb-2">リンクが無効です</p>
                        <p className="text-sm text-gray-600 mb-6">
                            この招待リンクは期限が切れているか、既に使用されています。
                        </p>
                        <a href="/app/login" className="text-blue-600 hover:underline text-sm">ログイン画面へ戻る</a>
                    </div>
                )}

                {status === "valid" && (
                    <div>
                        <div className="mb-6">
                            <p className="text-gray-600 text-sm mb-1">招待を確認しました</p>
                            <h2 className="break-words text-lg sm:text-xl font-bold text-gray-800">
                                {inviteInfo.company_name}
                            </h2>
                            <p className="text-gray-600 text-sm mt-2">
                                <span className="break-all font-medium">{inviteInfo.email}</span> として参加します
                            </p>
                        </div>

                        <div className="bg-blue-50 p-4 rounded-lg mb-8">
                            <p className="text-xs text-blue-700 leading-relaxed text-left">
                                ※ ログインに使用するGoogleアカウントのアドレスが上記と異なっていても、この招待枠に正しく紐付けられます。
                            </p>
                        </div>

                        <button
                            onClick={handleGoogleLogin}
                            className="w-full flex items-center justify-center gap-3 bg-white border border-gray-300 text-gray-700 font-bold py-3 px-4 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
                        >
                            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-5 h-5" />
                            Googleアカウントで開始
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Invite;
